export default __webpack_public_path__ + "static/media/17-lead.e19d0b55.png";